// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_sensory_session_status */
var FoodSensorySessionStatus;
(function (FoodSensorySessionStatus) {
    FoodSensorySessionStatus["draft"] = "draft";
    FoodSensorySessionStatus["active"] = "active";
    FoodSensorySessionStatus["closed"] = "closed";
})(FoodSensorySessionStatus || (FoodSensorySessionStatus = {}));
;
export default FoodSensorySessionStatus;
/** Zod schema for food_sensory_session_status */
export const foodSensorySessionStatus = z.nativeEnum(FoodSensorySessionStatus);
//# sourceMappingURL=FoodSensorySessionStatus.js.map